export interface IntrospectionStep {
  id: string;
  title: string;
  prompt: string;
  placeholder?: string;
}

export interface IntrospectionFlow {
  id: string;
  title: string;
  description: string;
  steps: IntrospectionStep[];
}

export const demoIntrospectionFlow: IntrospectionFlow = {
  id: "introspection-3-questions",
  title: "3 questions pour clarifier",
  description: "Une introspection rapide en 3 étapes.",
  steps: [
    {
      id: "int-1",
      title: "Ce que je ressens",
      prompt: "Que ressens-tu face à cette situation ?",
      placeholder: "Frustration, curiosité, doute...",
    },
    {
      id: "int-2",
      title: "Ce que je pense",
      prompt: "Quelles sont les pensées ou croyances qui t'accompagnent ?",
      placeholder: "Je pense que..., j'ai peur que...",
    },
    {
      id: "int-3",
      title: "Ce que je peux faire",
      prompt: "Quelle petite action concrète peux-tu tenter ?",
      placeholder: "Lire une source opposée, demander un avis extérieur...",
    },
  ],
};
